import {createFileRoute} from '@tanstack/react-router'
import {firstLevelIndexRoute} from "../../../../../../utils/collectionListing";

export const Route = createFileRoute('/_site/users/_public_profile/notwant/$username/$primarySorting/')({
    ...firstLevelIndexRoute("/users/notwant/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName"),
});
